import {Component, forwardRef, input, InputSignal} from '@angular/core';
import {NgClass} from '@angular/common';
import {ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR} from '@angular/forms';

@Component({
  selector: 'braidsbook-input-radio',
  imports: [NgClass, FormsModule],
  templateUrl: './input-radio.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputRadioComponent),
      multi: true
    }
  ]
})
export class InputRadioComponent implements ControlValueAccessor {
  name: InputSignal<string> = input.required();
  label: InputSignal<string> = input('');
  options: InputSignal<{label: string, value: string}[]> = input.required();
  selectedValue: string = '';
  linear: InputSignal<boolean> = input(false);

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  writeValue(obj: any): void {
    this.selectedValue = obj;
  }

  onChangeValue(value: string): void {
    this.selectedValue = value;
    this.onChange(value);
    this.onTouched();
  }

  private onTouched: () => void = () => {
  };

  private onChange: (value: string) => void = () => {
  };
}
